var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "transactions container",
    attrs: {
      "id": "million-bit-transactions"
    }
  }, [_c('h1', {
    staticClass: "pt-3 honk-text"
  }, [_vm._v("Pixels: "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.pixelCount)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "btn-group btn-block"
  }, [_c('button', {
    staticClass: "btn btn-icon btn-block btn-primary my-3",
    class: {
      'disabled': _vm.toggledView === 'mint'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleView()
      }
    }
  }, [_vm._v("\n          Mint\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-icon btn-block btn-primary my-3",
    class: {
      'disabled': _vm.toggledView === 'repaint'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleView()
      }
    }
  }, [_vm._v("\n          Repaint\n      ")])]), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, _vm._l((_vm.transactionsFiltered), function(transaction) {
    return _c('tr', {
      key: transaction._id
    }, [_c('td', [_c('b', {
      staticClass: "mr-1"
    }, [_vm._v(_vm._s(transaction.seq))]), _vm._v(" "), _c('a', {
      attrs: {
        "href": 'https://basescan.org/tx/' + transaction.hash,
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "external-link",
      attrs: {
        "src": "/static/external-link.svg",
        "alt": "View transaction"
      }
    })])]), _vm._v(" "), _c('td', {
      directives: [{
        name: "lazy-load",
        rawName: "v-lazy-load"
      }]
    }, [_c('img', {
      staticClass: "mr-4 my-4",
      attrs: {
        "data-url": _vm.s3Base + transaction.hash + '-crop.jpeg'
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "text-left link"
    }, [_c('a', {
      attrs: {
        "href": transaction.url,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(transaction.url))])]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_c('div', {
      staticClass: "btn-group"
    }, [_c('a', {
      staticClass: "btn btn-outline-primary btn-sm",
      attrs: {
        "href": 'https://magiceden.us/item-details/base/0x25b9afe64bb3593ec7e9dc7ef386a9b04c53f96e/' + transaction.tokenId,
        "target": "_blank"
      }
    }, [_vm._v("Magic Eden")])])])])
  }), 0)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52b1b3d2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Transactions.vue
// module id = FE7F
// module chunks = 2